module.exports = __webpack_public_path__ + "static/media/col9.3aaadedc.jpg";